import { ERROR_MSG, VALIDATION } from "../../../constants/app-constant";

const validateEmail = (value) => {
  return !VALIDATION.VALID_EMAIL_REGEX.test(value)
    ? ERROR_MSG.INVALID_EMAIL
    : "";
};

export const validate = {
  validateEmail,
};
